/**
 * TanStack Query hooks for `anomaly-alerts-ml-driven-unusual-activity-patterns`.
 * Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	acknowledge,
	list,
	anomalyAlertsQueryKeys,
	type AcknowledgeResponse,
	type ListAnomalyAlertsQuery,
	type ListAnomalyAlertsResponse,
} from "./api";

export function useAnomalyAlertsList(
	q: ListAnomalyAlertsQuery = {},
): UseQueryResult<ListAnomalyAlertsResponse, Error> {
	return useQuery({
		queryKey: anomalyAlertsQueryKeys.list(q),
		queryFn: () => list(q),
	});
}

export function useAnomalyAlertAcknowledge(): UseMutationResult<
	AcknowledgeResponse,
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: acknowledge,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: anomalyAlertsQueryKeys.all });
		},
	});
}
